module.exports = {
    name: 'Yabbr',
    shortName: 'Yabbr',
    company: 'Yabbr',
    logo: './yabbr-blue-logo.png',
    apiUrl: 'https://api.yabbr.io/2019-01-23/',
    portalUrl: 'https://go.yabbr.io/',
    chat: {
        name: 'Yabbr Chat',
    },
};
